import { ESignCeremony, ESignSigner, ESignSignerActionPayload, ESignSigner2FAInfo } from '@breathelife/types';

import ApiService from './ApiService';

export async function getESignCeremony(applicationId: string): Promise<ESignCeremony | null> {
  const response = await ApiService.getESignCeremony(applicationId);
  return response.data;
}

export async function cancelESignCeremony(applicationId: string): Promise<ESignCeremony | null> {
  const response = await ApiService.cancelESignCeremony(applicationId);
  return response.data;
}

export async function sendESignCeremony(
  applicationId: string,
  signers: ESignSigner2FAInfo[],
  inPerson: boolean,
): Promise<ESignCeremony | null> {
  const response = await ApiService.sendESignatureRequest(applicationId, signers, inPerson);
  return response.data;
}

export async function eSignSignerAction(payload: ESignSignerActionPayload): Promise<ESignSigner | null> {
  const response = await ApiService.eSignSignerAction(payload);
  return response.data;
}
